import api from "./axios";
import type { Vendor } from "../types/vendor";
import { mapVendorsResponse } from "../types/vendor";

export const getVendorsApi = async (): Promise<Vendor[]> => {
  try {
    const response = await api.get<any>("/api/v1/vendors");
    return mapVendorsResponse(response.data);
  } catch (error) {
    console.error("Error fetching vendors:", error);
    throw error;
  }
};

interface CreateVendorData {
  name: string;
}

export const createVendorApi = async (data: CreateVendorData) => {
  try {
    const response = await api.post("/api/v1/vendors", data);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor:", error);
    throw error;
  }
};

interface UpdateVendorData {
  name: string;
}

export const updateVendorApi = async (vendorId: string, data: UpdateVendorData) => {
  try {
    const response = await api.put(`/api/v1/vendors/${vendorId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating vendor:", error);
    throw error;
  }
};
